export const en = {
  nav_core: "Core",
  nav_analytics: "Research",
  nav_learning: "Learning",
  nav_tools: "Tools",
  nav_more: "More",
  nav_ai_engine: "AI Engine",
  nav_coming_soon: "Coming Soon",
  nav_private: "Private",
  nav_home: "Home",
  nav_finances: "Finances",
  nav_my_finances: "My Finances",
  nav_dashboard: "Dashboard",
  nav_holdings: "Holdings",
  nav_portfolio: "Portfolio",
  nav_discover: "Discover",
  nav_actions: "Actions",
  nav_search: "Search",
  nav_review: "Review",
  nav_research_council: "Research Council",
  nav_cashflow: "Cashflow",
  nav_debt_optimizer: "Debt Optimizer",
  nav_beam_academy: "BEAM Academy",
  nav_risk: "Risk",
  nav_watchlist: "Watchlist",
  nav_thesis: "Thesis",
  nav_income: "Income",
  nav_net_worth: "Net Worth",
  nav_relationships: "Relationships",
  nav_allocation: "Allocation",
  nav_stock_quality_score: "Stock Quality Score",
  nav_lens_score: "Lens Score",
  nav_process_score: "Process Score",
  nav_import: "Import",
  nav_accounts: "Accounts",
  nav_logout: "Logout",

  display_language: "Display Language",
  display_language_help: "App-wide language for navigation, onboarding, and key guidance.",
  language_updated: "Display language updated",
  language_update_failed: "Failed to update display language",

  dashboard_title: "Dashboard",
  dashboard_subtitle: "Portfolio overview and key metrics",
  dashboard_good_morning: "Good morning",
  dashboard_based_on_profile: "Based on your",
  dashboard_attention_today: "here's what may be worth your attention today.",
  dashboard_learning_prompt_note: "Learning prompts use your app context for research support, not instructions or recommendations.",
  dashboard_estimated_surplus: "Estimated investable surplus",
  dashboard_surplus_setup: "Set up Cashflow Planner to verify true deployable cash.",
  dashboard_health_score: "Financial wellness",
  dashboard_health_setup: "Set up cashflow and net worth to unlock Financial Wellness.",
  dashboard_growth_concentration: "Growth exposure concentration",
  dashboard_growth_concentration_detail: "Your portfolio is tilted toward high-growth businesses. Review source themes, quality evidence, and uncertainty before adding more risk.",
  dashboard_largest_concentration: "Largest concentration cue",
  dashboard_portfolio_setup: "Portfolio setup",
  dashboard_beam_gap_setup: "Add holdings to see possible BEAM role gaps.",
  dashboard_beam_roles_visible: "BEAM roles visible",
  dashboard_beam_roles_visible_detail: "Your current holdings show the main BEAM roles. Next step: review concentration and thesis quality.",
  dashboard_watchlist_study: "One name from your watchlist to study",
  dashboard_watchlist_study_detail: "Start by understanding the business model, valuation context, portfolio role, and risks before deciding.",
  dashboard_holding_review: "Review one holding you already own",
  dashboard_holding_review_detail: "Revisit what the business does, why you own it, and what evidence would change your thesis.",
  dashboard_start_business: "Start with one business to understand",
  dashboard_start_business_detail: "Add a ticker or watchlist item so the app can give you a learning prompt.",

  onboarding_salary_plan: "Financial freedom starts when salary has a plan.",
  onboarding_headline: "What do you want to understand first?",
  onboarding_step_reason: "What brings you here?",
  onboarding_step_learning: "How would you describe your investing style?",
  onboarding_step_insight: "Choose your first insight",
  onboarding_step_frame: "Your first Investing OS frame",
  onboarding_first_insight_fallback: "First insight",
  onboarding_step_count: "Step",
  onboarding_step_of: "of",
  onboarding_based_on_profile: "Based on your",
  onboarding_learning_profile: "research profile",
  learning_profile_cautious: "Cautious",
  learning_profile_balanced: "Balanced",
  learning_profile_aggressive: "Growth focused",
  onboarding_reason_start: "I want to start investing",
  onboarding_reason_invest: "I already invest",
  onboarding_reason_portfolio: "I want to understand my portfolio",
  onboarding_reason_paycheck: "I want to stop living paycheck to paycheck",
  onboarding_reason_business: "I want to understand businesses before buying",
  onboarding_insight_cashflow: "Check what cash may be investable",
  onboarding_insight_business: "Understand a company",
  onboarding_insight_portfolio: "Review my current holdings",
  onboarding_insight_quality: "Learn quality vs moonshot",
  onboarding_learning_cautious: "Safety first - I want steady growth, low risk",
  onboarding_learning_balanced: "Balanced - some growth, some safety",
  onboarding_learning_aggressive: "Growth focused - I can handle volatility",
  onboarding_learning_not_sure: "I'm not sure yet",
  onboarding_learning_note: "Your risk profile helps the app explain research tradeoffs and safety checks. It does not create financial advice or automatic allocation.",
  onboarding_learning_description: "Used for education and research context only, not investment advice.",
  onboarding_life_context_title: "Age is only one input",
  onboarding_age_range_label: "Age range (optional)",
  onboarding_life_stage_label: "Life stage (optional)",
  onboarding_money_timeline_label: "Money need timeline (optional)",
  onboarding_cashflow_stability_label: "Cashflow stability (optional)",
  onboarding_obligations_context_label: "Major obligations (optional)",
  onboarding_principle_protect_title: "Protect life first",
  onboarding_principle_protect_copy: "Do not invest money your life still needs.",
  onboarding_principle_business_title: "Understand the business",
  onboarding_principle_business_copy: "Learn what you own before you own more.",
  onboarding_principle_study_title: "Study before investing",
  onboarding_principle_study_copy: "Your next step is learning, not buying.",
  onboarding_estimated_surplus: "Rough estimated monthly investable surplus",
  onboarding_estimate_warning: "This is an estimate, not verified deployable cash.",
  onboarding_cashflow_cta: "Set up Cashflow Planner for accurate deployable cash",
  onboarding_income_label: "Monthly income",
  onboarding_income_placeholder: "Example: 50000",
  onboarding_expenses_label: "Required monthly expenses",
  onboarding_expenses_placeholder: "Rent, food, utilities",
  onboarding_obligations_label: "Debt / obligations",
  onboarding_obligations_placeholder: "Minimum payments",
  onboarding_buffer_label: "Desired cash buffer",
  onboarding_buffer_placeholder: "Monthly buffer target",
  onboarding_goals_label: "Optional monthly goal contribution",
  onboarding_goals_placeholder: "Sinking funds, family goals, travel fund",
  onboarding_company_label: "Ticker or company name",
  onboarding_company_placeholder: "Example: AAPL, CPALL, Microsoft",
  onboarding_business_note: "Learn what the business does before buying.",
  onboarding_business_detail: "Start with the business model, risks, valuation context, and what would change your thesis.",
  onboarding_portfolio_note: "We need holdings to show concentration, risk, and portfolio role.",
  onboarding_portfolio_detail: "Manual entry or import is enough. No broker connection is required.",
  onboarding_quality_note: "Quality compounders and moonshots are not the same game.",
  onboarding_quality_detail: "Study moat, reinvestment runway, balance sheet risk, valuation, and what could break the thesis.",
  onboarding_first_frame_detail: "Set up Cashflow Planner to verify true deployable cash, and use research tools to study before deciding.",

  disclaimer_short: "For education only. Not financial advice.",
  disclaimer_full: "These outputs are for education and research support only. They are not financial advice, not a recommendation to buy or sell, and not a guarantee of returns. Always do your own research and make your own final decision.",
  disclaimer_personalized: "Analytics tailored to your portfolio data. ROOH is not a broker-dealer and does not provide personalized investment advice. Not a buy/sell recommendation or return guarantee. You make every final decision.",

  btn_back: "Back",
  btn_cancel: "Cancel",
  btn_continue: "Continue",
  btn_enter_app: "Enter Investing OS",
  btn_generate: "Generate",
  btn_import: "Import holdings",
  btn_manual: "Add manually",
  btn_open_cashflow: "Open Cashflow Planner",
  btn_open_research: "Open business research",
  btn_explore: "Explore candidates",
  btn_save: "Save",
  btn_skip: "Skip",
  btn_start_learning: "Start learning",
};
